import { ActionAny, createActions } from 'src/utils/createActions';

export type ItemImageUploadResetActions =
    ActionAny<null, null>;
export const ITEM_IMAGE_UPLOAD_RESET_ACTIONS =
    createActions<null, null>('ITEM_IMAGE_UPLOAD_RESET');
